// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1D9Un","right":"Footer_right__2Fp3_","buttons":"Footer_buttons__eRvxl"};